export default __webpack_public_path__ + "static/media/GothaBoo.92921fda.otf";